const user_workflows = {
  title: "Mis Flujos",
  saved: "Flujo guardado.",
  deleted: "Flujo eliminado.",
};

export default user_workflows;
